import * as React from "react";
import { Loader } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useAddToCart } from "../../../../../../hooks/hooks/use-add-to-cart.js";
import { AddButton } from "../../../../components/modules/Upsell/components/AddButton.js";
/* empty css                                                               */
const AddButtonContainer = ({ lineItemDrafts, onSuccess }) => {
  const { getLabel } = useIntl();
  const [addToCart, { loading }] = useAddToCart();
  const labels = React.useMemo(
    () => ({
      addToCart: getLabel("cart.actions.addToCart")
    }),
    [getLabel]
  );
  const handOnClick = React.useCallback(
    () => addToCart(lineItemDrafts, onSuccess),
    [addToCart, lineItemDrafts, onSuccess]
  );
  return loading ? /* @__PURE__ */ React.createElement(Loader, { className: "add-button__loader" }) : /* @__PURE__ */ React.createElement(AddButton, { caption: labels.addToCart, onClick: handOnClick });
};
export {
  AddButtonContainer
};
//# sourceMappingURL=AddButtonContainer.js.map
